import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { PersonaSearchService } from 'src/app/services/persona-search.service';
import { Router } from '@angular/router';
import { Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'apc-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent {
  quickSearch = new Subject<any>();
  queryString: string = '';
  searchValue: string = '';
  result: any = '';
  isLoading: boolean = false;
  @Output() findUserEvent = new EventEmitter<string>();
  @Input() isOpen: boolean = false;
  @Input() dataObj: any;
  @Input() showEnvWarning: boolean;
  @ViewChild("searchPersonaField") searchPersonaField;
  constructor(private personaSearchService: PersonaSearchService, private router: Router) {
    this.quickSearch.pipe(debounceTime(1000), distinctUntilChanged()).subscribe((input) => {
      this.search(input.value);
    });
  }

  redirectToUser(identifier: string) {
    this.findUserEvent.emit(identifier);
    this.searchPersonaField.nativeElement.focus();
    this.result = [];
    this.searchValue = '';
    this.queryString = '';
  }

  async search(value: string) {
    this.searchValue = value;
    this.queryString = this.searchValue;
    this.isLoading = true;
    if (this.queryString.length > 0) {
      this.result = this.dataObj.filter((v) => v.name?.toLowerCase()?.indexOf(this.queryString.toLowerCase()) > -1 || v.manager_name?.toLowerCase()?.indexOf(this.queryString.toLowerCase()) > -1 ).slice(0, 10);
      let managerResults=[];
      this.result.forEach(element => {
        if((element.type=="AREA" || element.type == "TEAM") && element.manager_identifier){
          managerResults = [...this.result.filter(rd=>rd.manager_identifier===element.manager_identifier)];
        }
      });
      if(managerResults.length>1){
        let idManagerFound=[];
        this.result = this.result.filter((el)=>{
          if((el.type=="AREA" || el.type == "TEAM") && el.manager_identifier){
            return this.result.filter((fl)=>{
              if(el.manager_identifier === fl.manager_identifier){
                if(!idManagerFound.find(f=>f === el.manager_identifier)){
                  idManagerFound.push(el.manager_identifier);
                  return el;
                }              
              }
            })[0];
          }else{
            return el;
          }
        })
      }  
      this.isLoading = false;
    } else {
      this.result = [];
      this.isLoading = false;
    }
  }

  openSearch() {
    this.isOpen = true;
    //setTimeout(() => document.getElementById('quick-search').focus(), 200);
  }

  closeSearch() {
    //this.isOpen = false;
    this.searchPersonaField.nativeElement.focus();
    this.result = [];
    this.searchValue = '';
    this.queryString = '';
  }

}
